import { observable, computed, makeObservable } from 'mobx';
import { get } from '@utils/get';
import ListStore from '@stores/list';

// Store：兼容 list 组件用法，提供统一的列表数据、状态、属性获取接口
export class TopicStore {
    @observable namespace = 'topic';
    @observable topicDetail = null;  // 确保有这个属性
    @observable topicList = null;
    @observable followTopicList = null;
    @observable followTopicFocusId = '';    // 导航上当前的话题焦点id
    @observable topicThreadList = null;
    @observable allTopicsData = null;  // 缓存所有话题数据
    @observable categoryList = [];     // 缓存所有分类
    @observable categoryMap = {};      // 分类名 -> ID 映射
    @observable topicsLoading = false; // 加载所有话题时的状态

    constructor(initData = {}) {
        this.listStore = new ListStore();
        // 注册业务list
        this.listStore.registerList({ namespace: 'topicList' });
        // 初始化数据（兼容 SSR/初始注入）
        if (initData.topicList) {
            this.listStore.lists['topicList'].data = initData.topicList;
        }

        // 注册业务list
        this.listStore.registerList({ namespace: 'topicThreadList' });
        // 初始化数据（兼容 SSR/初始注入）
        if (initData.topicThreadList) {
            this.listStore.lists['topicThreadList'].data = initData.topicThreadList;
        }
    }

    /**
     * 获取列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get topicListData() {
        return this.listStore.getList({ namespace: 'topicList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get topicListAttribs() {
        return this.listStore.lists['topicList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get topicListLoading() {
        return this.listStore.lists['topicList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get topicListError() {
        return this.listStore.lists['topicList']?.requestError || { isError: false, errorText: '' };
    }

    /**
     * 获取列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get topicThreadListData() {
        return this.listStore.getList({ namespace: 'topicThreadList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get topicThreadListAttribs() {
        return this.listStore.lists['topicThreadList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get topicThreadListLoading() {
        return this.listStore.lists['topicThreadList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get topicThreadListListError() {
        return this.listStore.lists['topicThreadList']?.requestError || { isError: false, errorText: '' };
    }
}

// 不再导出 Store 实例，全部用 Action 实例